<template>
  <div class="register-root">
    <div class="register-main">
      <div class="register-img"></div>
      <div class="register-scroll">
        <div class="login-link">
          {{$t('register.alreadyHave')}} <el-link type="primary" @click="goToLogin" style="margin-left: 6px">{{$t('register.signIn')}}</el-link>
        </div>
        <div class="title-box"  v-if="verify">
          <h2>{{$t('register.title')}}</h2>
          <p class="subtitle">{{$t('register.subtitle')}}</p>
        </div>
        <div class="register-box" v-if="!verify">
          <el-form
            :model="emailForm"
            :rules="emailRules"
            ref="emailForm"
            label-width="140px"
            style="width: 100%"
          >
            <el-row :gutter="16" style="margin: 0 !important;">
              <div style="font-size: 24px;font-weight: bold;margin: 24px 0">{{$t('register.confirmTitle')}}</div>
              <div style="margin: 36px 0">{{$t('register.sentTo')}} <span style="font-weight: bold">{{ emailForm.email}}</span> </div>
              <div style="font-weight: bold;margin: 24px 0">{{$t('register.enterCode')}}</div>
              <verify-code-input
                v-model="emailForm.verificationCode"
                :length="6"
              />
              <div style="margin: 24px 0">{{$t('register.resendHint')}} <span @click="getVerificationCode" style="color: #1890ff;cursor: pointer">{{$t('register.resend')}}</span> {{$t('register.or')}} <span @click="verify=!verify" style="color: #1890ff;cursor: pointer">{{$t('register.updateEmail')}}</span>.</div>
            </el-row>
          </el-form>

            <div style="width: 100%">
              <el-button style="width: 100%" type="primary" @click="handleEmailVerification" :loading="verifying">{{$t('register.continue')}}</el-button>
            </div>
        </div>
        <div class="register-box" v-if="verify">
          <div class="guardian">
            {{$t('register.guardian')}}
            <el-button icon="el-icon-plus" @click="addChild" class="add-child-btn">{{$t('register.addChildren')}}</el-button>
          </div>
          <el-form :model="formData" :rules="rules" ref="registerForm" label-width="200px" style="width: 100%">
            <!-- 监护人信息 -->
            <el-row :gutter="16" style="margin: 0 !important;">
              <el-form-item :label="$t('register.username')" prop="parent.userAccount">
                <el-input v-model="formData.parent.userAccount" />
              </el-form-item>
              <el-form-item :label="$t('register.preferredName')" prop="parent.username">
                <el-input v-model="formData.parent.username" />
              </el-form-item>
              <el-form-item :label="$t('register.email')" prop="parent.email">
                <el-input v-model="formData.parent.email" />
              </el-form-item>
              <el-form-item :label="$t('register.gender')" prop="parent.sex">
                <el-select v-model="formData.parent.sex" style="width: 100%">
                  <el-option :label="$t('register.male')" value="1" />
                  <el-option :label="$t('register.female')" value="2" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('register.nationality')" prop="parent.country">
                <el-input v-model="formData.parent.country" />
              </el-form-item>
              <el-form-item :label="$t('register.phone')" prop="parent.tel">
                <el-input v-model="formData.parent.tel" />
              </el-form-item>
              <el-form-item :label="$t('register.password')" prop="parent.password">
                <el-input type="password" v-model="formData.parent.password" show-password />
              </el-form-item>
              <el-form-item :label="$t('register.confirmPassword')" prop="parent.rePassword">
                <el-input type="password" v-model="formData.parent.rePassword" show-password />
              </el-form-item>
            </el-row>

            <!-- children信息 -->
            <div v-for="(child, idx) in formData.children" :key="idx" class="child-box">
              <el-divider>Child {{ idx + 1 }} <i class="el-icon-delete-solid" @click="delChild(idx)"/> </el-divider>
              <el-row :gutter="16" class="form-row">
                <el-form-item :label="$t('register.username')" :prop="`children.${idx}.userAccount`">
                  <el-input v-model="child.userAccount" />
                </el-form-item>
                <el-form-item :label="$t('register.preferredName')" :prop="`children.${idx}.username`">
                  <el-input v-model="child.username" />
                </el-form-item>
                <el-form-item :label="$t('register.email')" :prop="`children.${idx}.email`">
                  <el-input v-model="child.email" />
                </el-form-item>
                <el-form-item :label="$t('register.gender')" :prop="`children.${idx}.sex`">
                  <el-select v-model="child.sex" style="width: 100%">
                    <el-option :label="$t('register.male')" value="1" />
                    <el-option :label="$t('register.female')" value="2" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('register.age')" :prop="`children.${idx}.age`">
                  <el-input-number v-model="child.age" :min="1" :max="100" style="width: 100%" />
                </el-form-item>
                <el-form-item :label="$t('register.nationality')" :prop="`children.${idx}.country`">
                  <el-input v-model="child.country" />
                </el-form-item>
                <el-form-item :label="$t('register.grade')" :prop="`children.${idx}.grade`">
                  <el-select v-model="child.grade" style="width: 100%" placeholder="please select">
                    <el-option :label="$t('register.gradeOne')" value="1" />
                   <el-option :label="$t('register.gradeTwo')" value="2" />
                   <el-option :label="$t('register.gradeThree')" value="3" />
                   <el-option :label="$t('register.gradeFour')" value="4" />
                   <el-option :label="$t('register.gradeFive')" value="5" />
                   <el-option :label="$t('register.gradeSix')" value="6" />
                   <el-option :label="$t('register.gradeSeven')" value="7" />
                   <el-option :label="$t('register.gradeEight')" value="8" />
                   <el-option :label="$t('register.gradeNine')" value="9" />
                   <el-option :label="$t('register.gradeTen')" value="10" />
                   <el-option :label="$t('register.gradeEleven')" value="11" />
                   <el-option :label="$t('register.gradeTwelve')" value="12" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('register.password')" :prop="`children.${idx}.password`">
                  <el-input type="password" v-model="child.password" show-password />
                </el-form-item>
                <el-form-item :label="$t('register.confirmPassword')" :prop="`children.${idx}.rePassword`">
                  <el-input type="password" v-model="child.rePassword" show-password />
                  </el-form-item>
              </el-row>
            </div>
          </el-form>
          <div class="register-btn-wrap">
            <el-button type="primary" class="register-btn" @click="handleRegister">{{$t('register.registerBtn')}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      {{$t('register.footer')}}
    </div>
  </div>
</template>

<script>
import { parentAddWithUsers, existAccount, getVerificationCode, verifyEmail } from '@/api/user'
import { encrypt } from '@/utils/crypto'
import VerifyCodeInput from '@/components/VerifyCodeInput.vue'

/**
 * @description 注册页面组件
 */
export default {
  name: 'Register',
  components: {
    VerifyCodeInput
  },
  data () {
    // children确认密码校验，动态获取children索引
    const validateChildPass2 = (rule, value, callback) => {
      const match = rule.fullField.match(/^children\.(\d+)\.rePassword$/)
      const idx = match ? Number(match[1]) : -1
      if (idx > -1 && value !== this.formData.children[idx].password) {
        callback(new Error(this.$t('validation.passVerifyFailed')))
      } else {
        callback()
      }
    }
    // 监护人确认密码校验
    const validateParentPass2 = (rule, value, callback) => {
      if (value !== this.formData.parent.password) {
        callback(new Error(this.$t('validation.passVerifyFailed')))
      } else {
        callback()
      }
    }
    // 账号唯一性校验
    const validateAccountUnique = async (rule, value, callback) => {
      if (!value) return callback()
      try {
        const res = await existAccount({ userAccount: value })
        if (res.code === 200) {
          callback()
        } else {
          callback(new Error(this.$t('validation.accountExists')))
        }
      } catch (e) {
        callback(new Error(this.$t('validation.accountVerifyFailed')))
      }
    }
    // 邮箱唯一性校验
    const validateEmailUnique = async (rule, value, callback) => {
      if (!value) return callback()
      try {
        const res = await existAccount({ userAccount: value })
        if (res.code === 200) {
          callback()
        } else {
          callback(new Error(this.$t('validation.emailExists')))
        }
      } catch (e) {
        callback(new Error(this.$t('validation.emailVerifyFailed')))
      }
    }
    return {
      verify: true, // 是否显示注册表单
      emailForm: {
        email: '',
        verificationCode: ''
      },
      emailRules: {
        email: [
          { required: true, message: this.$t('validation.enterEmailAddress'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.correctEmailFormat'), trigger: 'blur' },
          { validator: validateEmailUnique, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: this.$t('validation.enterVerificationCode'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('validation.sixDigitCode'), trigger: 'blur' }
        ]
      },
      isCodeSent: false,
      verifying: false,
      formData: {
        parent: {
          userAccount: '',
          username: '',
          sex: '1',
          password: '',
          rePassword: '',
          tel: '',
          country: '',
          email: ''
        },
        children: []
      },
      rules: {
        // 监护人规则
        'parent.userAccount': [
          { required: true, message: this.$t('validation.enterUserAccount'), trigger: 'blur' },
          { min: 3, max: 20, message: this.$t('validation.length3to20'), trigger: 'blur' },
          { validator: validateAccountUnique, trigger: 'blur' }
        ],
        'parent.username': [
          { required: true, message: this.$t('validation.enterUsername'), trigger: 'blur' }
        ],
        'parent.email': [
          { required: true, message: this.$t('validation.enterEmailAddress'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.correctEmailFormat'), trigger: 'blur' },
          { validator: validateEmailUnique, trigger: 'blur' }
        ],
        'parent.sex': [
          { required: true, message: this.$t('validation.selectGender'), trigger: 'change' }
        ],
        'parent.country': [
          { required: true, message: this.$t('validation.enterNationality'), trigger: 'blur' }
        ],
        'parent.tel': [
          { required: true, message: this.$t('validation.enterPhone'), trigger: 'blur' }
        ],
        'parent.password': [
          { required: true, message: this.$t('validation.enterPassword'), trigger: 'blur' },
          { min: 6, message: this.$t('validation.passwordMin6'), trigger: 'blur' }
        ],
        'parent.rePassword': [
          { required: true, message: this.$t('validation.enterPasswordAgain'), trigger: 'blur' },
          { validator: validateParentPass2, trigger: 'blur' }
        ]
      },
      validateChildPass2,
      validateAccountUnique,
      validateEmailUnique
    }
  },
  methods: {
    /**
     * @description 添加子女
     */
    addChild () {
      const idx = this.formData.children.length
      this.formData.children.push({
        userAccount: '',
        username: '',
        sex: '1',
        age: 10,
        password: '',
        rePassword: '',
        country: '',
        email: '',
        grade: ''
      })
      // 动态添加children校验规则
      this.$set(this.rules, `children.${idx}.userAccount`, [
        { required: true, message: this.$t('validation.enterUserAccount'), trigger: 'blur' },
        { min: 3, max: 20, message: this.$t('validation.length3to20'), trigger: 'blur' },
        { validator: this.validateAccountUnique, trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.username`, [
        { required: true, message: this.$t('validation.enterUsername'), trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.sex`, [
        { required: true, message: this.$t('validation.selectGender'), trigger: 'change' }
      ])
      this.$set(this.rules, `children.${idx}.age`, [
        { required: true, message: this.$t('validation.enterAge'), trigger: 'blur' },
        { type: 'number', message: this.$t('validation.ageMustBeNumber'), trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.country`, [
        { required: true, message: this.$t('validation.enterNationality'), trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.grade`, [
        { required: true, message: this.$t('validation.enterGrade'), trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.password`, [
        { required: true, message: this.$t('validation.enterPassword'), trigger: 'blur' },
        { min: 6, message: this.$t('validation.passwordMin6'), trigger: 'blur' }
      ])
      this.$set(this.rules, `children.${idx}.rePassword`, [
        { required: true, message: this.$t('validation.enterPasswordAgain'), trigger: 'blur' },
        { validator: this.validateChildPass2, trigger: 'blur' }
      ])
      // children邮箱非必填
      this.$set(this.rules, `children.${idx}.email`, [
        { type: 'email', message: this.$t('validation.correctEmailFormat'), trigger: 'blur' },
        { validator: this.validateEmailUnique, trigger: 'blur' }
      ])
    },
    /**
     * @description 处理注册请求
     */
    handleRegister () {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.verify = false
          this.emailForm.email = this.formData.parent.email
          this.getVerificationCode()
        }
      })
    },
    register () {
      const parent = { ...this.formData.parent }
      parent.password = encrypt(parent.password)
      delete parent.rePassword
      const users = this.formData.children.map(child => {
        const c = { ...child }
        c.password = encrypt(c.password)
        delete c.rePassword
        return c
      })
      parentAddWithUsers({ parent, users }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('register.msg.registerSuccess'))
          this.$router.push('/login')
        } else {
          this.$message.error(res.message || this.$t('register.msg.registerFailed'))
        }
      })
    },
    /**
     * @description 跳转到登录页面
     */
    goToLogin () {
      this.$router.push('/login')
    },
    /**
     * @description 获取验证码
     */
    getVerificationCode () {
      const params = {
        email: this.emailForm.email
      }
      getVerificationCode(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('register.msg.codeSent'))
            this.isCodeSent = true
          } else {
            this.$message.error(res.message || this.$t('register.msg.getCodeFailed'))
          }
        })
        .catch(() => {
          this.$message.error(this.$t('register.msg.getCodeFailed'))
        })
    },
    /**
     * @description 处理邮箱验证
     */
    handleEmailVerification () {
      // 验证验证码
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          this.verifying = true
          const params = {
            email: this.emailForm.email,
            verificationCode: this.emailForm.verificationCode
          }
          verifyEmail(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('register.msg.verifySuccess'))
                this.register()
              } else {
                this.$message.error(res.message || this.$t('register.msg.verifyError'))
              }
            })
            .catch(() => {
              this.$message.error(this.$t('register.msg.verifyFailed'))
            })
            .finally(() => {
              this.verifying = false
            })
        }
      })
    },
    delChild (idx) {
      // 确保 idx 是有效的索引
      if (idx >= 0 && idx < this.formData.children.length) {
        // 使用 Vue 的 $set 方法进行响应式删除
        this.formData.children.splice(idx, 1)

        // 同步更新校验规则
        this.$delete(this.rules, `children.${idx}`)
      }
    }

  }
}
</script>

<style scoped>
.register-root {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  position: relative;
  overflow: hidden;
  background: url("~@/assets/Register-bg.png") no-repeat center/100% 100%;
}

.register-main {
  flex: 1 1 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
}
.register-img{
  height: 100%;
  width: 50%;
}
.register-scroll {
  width: 50%;
  .title-box {
    width: 100%;
    max-width: 100%;
    padding: 20px calc(40% - 226px) 10px calc(60% - 226px);
    flex-shrink: 0;
    h2 {
      color: #1e88e5;
      margin-bottom: 8px;
      text-align: center;
      font-size: 24px;
      font-family: 'AzonixRegular', sans-serif !important;
    }
    .subtitle {
      text-align: center;
      color: #666;
      font-size: 14px;
    }
  }
  .login-link {
    margin: 18px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    font-family: 'AzonixRegular', sans-serif !important;
  }
  :deep(.el-link--inner) {
    font-family: 'AzonixRegular', sans-serif !important;
  }
}
.register-box {
  width: 100%;
  padding: 0 calc(40% - 226px) 0 calc(60% - 226px);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 180px);
  overflow-y: auto;
  .guardian{
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.child-box {
  margin-top: 48px;
}
.register-btn-wrap {
  display: flex;
  justify-content: center;
  background: #fff;
  z-index: 10;
  padding: 8px 0;
  width: 100%;
}
.register-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
}
.add-child-btn {
  margin-top: 10px;
  width: 30%;
  min-width: 190px;
}
.footer {
  text-align: center;
  padding: 8px 28% 4px;
  color: #666;
  font-size: 13px;

}
:deep(.el-form-item) {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
:deep(.el-form-item__label) {
  width: auto;
  min-width: 80px;
  max-width: 40vw;
  word-break: break-all;
  white-space: normal;
  box-sizing: border-box;
  text-align: left;
  line-height: 21px;
  font-weight: 500;
  margin-bottom: 4px;
  font-size: 14px;
  color: #1f2328;
}
:deep(.el-form-item__content) {
  margin: 0 !important;
}
:deep(.el-form-item__error) {
  margin-bottom: 4px;
}
:deep(.el-input__inner) {
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
}
:deep(.el-select) {
  width: 100%;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .register-main {
    flex-direction: column;
    padding: 0;
    width: 100%;
    min-width: 0;
    align-items: stretch;
  }
  .register-img {
    display: none;
  }
  .register-scroll {
    width: 100%;
    min-width: 0;
    height: 100%;
  }
  .title-box {
    padding: 10px 4vw 6px 4vw;
    h2 {
      font-size: 20px;
    }
    .subtitle {
      font-size: 12px;
    }
  }
  .register-box {
    padding: 0 2vw 10px 2vw;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    .guardian {
      font-size: 16px;
      margin-bottom: 12px;
      width: 100%;
      box-sizing: border-box;
    }
  }
  .child-box {
    padding: 0 2vw;
    width: 100%;
    box-sizing: border-box;
  }
  .register-btn, .add-child-btn {
    font-size: 15px;
    height: 38px;
    box-sizing: border-box;
  }
  :deep(.el-form) {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }
  :deep(.el-form-item) {
    margin-bottom: 10px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  :deep(.el-form-item__label) {
    font-size: 13px;
    line-height: 20px;
    padding-bottom: 2px;
    width: auto;
    min-width: 80px;
    max-width: 40vw;
    word-break: break-all;
    white-space: normal;
    box-sizing: border-box;
    text-align: left;
  }
  :deep(.el-form-item__content) {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  :deep(.el-input__inner),
  :deep(.el-input-number),
  :deep(.el-select) {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
    font-size: 13px;
  }
  .footer {
    font-size: 12px;
    padding: 6px 0 2px 0;
    .login-link {
      font-size: 13px;
    }
  }
  .register-btn-wrap {
    padding: 4px 0;
    bottom: 44px;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
